module.exports = __webpack_public_path__ + "assets/img/project-panels-thumb.3d6bfa83.jpg";